// @flow weak
import React, { Component } from 'react'
import { connect } from 'react-redux'
import {PatientActions}  from '../reducers/patient/index'
import {
    Button,
    Col,
    Row
} from '@sketchpixy/rubix'

class RectPython extends Component {
    constructor(props) {
        super(props)
        this.state = {            
            question: '',
            option: '',
            page:'',
            url:'',
            questionRect: '',
            optionRect: '',
            response: ''
        }
    }
   

    getRects = () => {
        this.setState({url: "", response: "" })
        let token = localStorage.getItem('login_token');
        let headers = {"Content-Type": "application/json"};
        headers["Authorization"] = `Bearer ${token}`
        fetch(process.env.API_URL+"/dbq/rect", {method: "post", headers, body: JSON.stringify(this.state)} )
        .then(response => response.json())
        .then(data => {
            this.setState({response: data.data })
            this.setState({url: data.highlightedFileUrl+"?#page="+this.state.page })
        })
        .catch((error) => {
        console.error('Error:', error);
        }); 
    }

    render() {        
        let { question, option, page} = this.state;
        return (
            <div >
                <Row className="">
                    <Col lg={5} className="text-center">                        
                        <div  key="101"  >
                            <textarea style={{fontSize: 18}}
                                name="qarea"
                                id="1"
                                placeholder="Please enter Main Question" 
                                rows="2"
                                value={question}
                                onChange={e => this.setState({ question: e.target.value })}
                                className='required textarea-blue text-area'>
                            </textarea>
                        </div>
                        <div>{this.state.questionRect}</div>
                    </Col>
                    <Col lg={1} className="text-center">                        
                        <div  key="104"  >
                            <textarea style={{fontSize: 18}}
                                name="qarea"
                                id="1"
                                rows="2"
                                value={page}
                                onChange={e => this.setState({ page: e.target.value })}
                                className='required textarea-blue text-area'>
                            </textarea>
                        </div>
                        <div>{this.state.page}</div>
                    </Col>
                    <Col lg={4} className="text-center">                        
                        <div  key="102"  >
                            <textarea style={{fontSize: 18}}
                                name="qoption"
                                id="1"
                                placeholder="Please enter Option" 
                                rows="2"
                                value={option}
                                onChange={e => this.setState({ option: e.target.value })}
                                className='required textarea-blue text-area'>
                            </textarea>
                        </div>
                        <div>{this.state.optionRect}</div>
                    </Col>
                    <Col lg={2} className="text-center">                        
                        <div  key="103"  >
                        <Button
                            lg
                            type='button'
                            bsStyle='primary'
                            className="next-btn big-btn accept-btn-width"
                            onClick={this.getRects}>Send
                        </Button>
                        </div>
                    </Col>
                </Row>
                {
                    this.state.response ?
                <Row className="">
                    <Col sm={12}className="text-center">
                    <div className="correct-note-div">{this.state.response}</div>
                    </Col>
                </Row>
                 :""
                }
                {
                    this.state.url ?
                    <Row className="height400" style={{marginBottom: 100}}>
                        <Col xs={12} smOffset={1} sm={10} className="text-center">
                            <div style={{marginTop:30}}>
                                <object width="100%" height="600" data={this.state.url} type="application/pdf">   </object>
                            </div>
                        </Col>
                    </Row>
                     :""
                    }
            </div>
        )
    }
}


const mapStateToProps = state => ({
    patient: {
        specific: {
            patientInfo, fetching, error, isPatientUpdate
        }
    },
  }) => {
   return {
    patientInfo,
    fetching,
    error,
    isPatientUpdate
   }
}

const mapDispatchToProps = dispatch => ({
    updatePatientDoc: (id, dbq, questions, ssn, status, patientName) => {
        dispatch(PatientActions.updateSpecificPatientRequest({
            id,
            dbq,
            questions,
            ssn,
            status,
            patientName
        }))
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(RectPython)
